angular.module('eStories.carousel.service', [])

    .service('CarouselService', [
        '$rootScope',
        function ($rootScope) {

            this.needsAudiobookObjInput = () => {
                return [
                    'eStories.navbars',
                    'eStories.navbars.resetPw',
                    'eStories.navbars.vipSignUp',
                    'eStories.navbars.wishList',
                    'eStories.navbars.library',
                    'eStories.navbars.signIn',
                    'eStories.navbars.signUp',
                    'eStories.navbars.freemium',
                    'eStories.navbars.newUser',
                    'eStories.navbars.redeemGift',
                    'eStories.navbars.startTrial'
                ].indexOf($rootScope.currentState) !== -1;
            };

            this.getAudiobookObj = book => {
                if (!book) return;
                return this.needsAudiobookObjInput() ? book.audiobook : book;
            };

            this.setIndexes = (index, arrayLength) => {
                return {
                    previousIndex: (index - 1 + arrayLength) % arrayLength,
                    currentIndex: index % arrayLength,
                    nextIndex: (index + 1) % arrayLength
                }
            };
        }]);

class CarouselPagination {
    constructor(sectionItemList, panelLength, $window) {
        this.panelLength = panelLength;
        this.$window = $window;
        this._setSectionItemList(sectionItemList);
        this.pagination = {page: 0, size: this.getPanelLength()};
    }

    _setSectionItemList = (sectionItemList) => {
        if (!sectionItemList || !sectionItemList.length) {
            sectionItemList = new Array(this.getPanelLength()).fill({audiobook: {}})
        }
        this.sectionItemList = sectionItemList;
    };

    getPanelLength = () => {
        const viewPortWidth = this.$window.innerWidth;
        let len = null;
        if (viewPortWidth > 1180) {
            len = this.panelLength;
        } else if (viewPortWidth <= 1180 && viewPortWidth > 600) {
            len = this.panelLength === 12 ? 10 : this.panelLength;
        }
        return len;
    };

    getPagination = () => {
        this.pagination.size = this.getPanelLength();
        return this.pagination;
    };

    getPanelData = () => {
        // We return all section item list if it's mobile.
        if (!this.getPanelLength()) {
            return this.sectionItemList;
        }

        const pagination = this.getPagination();
        const startFrom = pagination.page * pagination.size;
        return this.sectionItemList.slice(startFrom, startFrom + pagination.size);
    };

    getNumberOfPages = () => {
        const panelLength = this.getPanelLength();
        if (!panelLength) {
            return 1;
        }
        return Math.ceil(this.sectionItemList.length / panelLength)
    };

    nextPage = () => {
        const pagination = this.getPagination();
        const numberOfPages = this.getNumberOfPages();
        pagination.page = (pagination.page + 1) % numberOfPages;
    };

    previousPage = () => {
        const pagination = this.getPagination();
        const numberOfPages = this.getNumberOfPages();
        pagination.page = (pagination.page - 1 + numberOfPages) % numberOfPages;
    };

    setPage = (pageIndex) => {
        this.getPagination().page = pageIndex;
    };

    getNumberOfPagesArray = () => new Array(this.getNumberOfPages());

    getCurrentPageIndex = () => this.getPagination().page;

}
